export const DEFAULT_STOP = 1.5;
export const DEFAULT_PROFIT = 'let_run';
export const MIN_BUY_USDC = 5;
export const MAX_AUTO_COINS = 5;

export const PREDATORS = [
    {
        id: 'top_hunter',
        index: '01',
        name: 'Viés de 5 dias',
        tag: 'Opção 1',
        summary: 'Entra na moeda que andou melhor nos últimos cinco dias, acompanha a alta e vende na reversão.',
        pitch: 'Esta opção olha cinco dias de caminho e compra quando o sinal técnico confirma. Daí o trade sobe junto com a moeda. O piso mínimo é 1,2%. Se ela for a 3%, a 5% ou a 7%, o lucro vai junto. A venda sai quando a alta reverte.',
        beats: [
            {
                title: 'Como escolhe a moeda',
                text: 'O radar lê o viés dos últimos cinco dias. A chance mínima vale para esse viés: a moeda precisa chegar nesse número para o trade abrir. O saldo é dividido entre as moedas, e cada uma recebe a sua parte.'
            },
            {
                title: 'Quando compra',
                text: 'A compra sai sozinha, no valor reservado para aquela moeda, quando o sinal técnico confirma. Antes disso a opção só observa.'
            },
            {
                title: 'Como faz o lucro',
                text: 'O trade acompanha a alta. O piso mínimo é 1,2%: é o primeiro degrau em que o lucro passa a ser protegido. Não existe um máximo fechado. Se a moeda sobe 3%, o trade está em 3%. Se sobe 5% ou 7%, ele continua acompanhando. A venda acontece na reversão, quando a moeda para de subir e vira.'
            }
        ],
        sells: true
    },
    {
        id: 'technical_signal',
        index: '02',
        name: 'Sinal técnico',
        tag: 'Opção 2',
        summary: 'Compra quando o sinal COMPRAR acende, acompanha a alta e vende na reversão.',
        pitch: 'Esta opção entra pelo sinal do gráfico, no instante do COMPRAR. O trade acompanha a moeda enquanto ela sobe. O piso é 1,2%, e o lucro pode ir a 3%, 5% ou 7%. A venda sai na reversão.',
        beats: [
            {
                title: 'Como escolhe a moeda',
                text: 'A chance mínima aqui é a chance do sinal, não o viés de cinco dias. Uma moeda pode ter andado bem na semana e ficar de fora se o sinal ainda estiver fraco.'
            },
            {
                title: 'Quando compra',
                text: 'O gatilho é o cruzamento do MACD, o mesmo do Radar e do Monitor. Quando esse cruzamento vira COMPRAR, a compra sai sozinha, no valor reservado para a moeda.'
            },
            {
                title: 'Como faz o lucro',
                text: 'Depois da compra, o trade sobe junto com a moeda. O piso mínimo é 1,2%. O máximo é variável: 3% numa alta curta, 5% numa alta média, 7% quando a moeda estica. A venda sai na reversão, quando a subida perde força e o preço vira.'
            }
        ],
        sells: true
    },
    {
        id: 'market_confluence',
        index: '03',
        name: 'Confluência',
        tag: 'Opção 3',
        summary: 'Compra com o Bitcoin a favor, acompanha a alta da moeda e vende na reversão.',
        pitch: 'Esta opção só abre trade com o Bitcoin em alta no gráfico de 4 horas e com a moeda confirmando no de 1 hora. O trade acompanha a subida. O piso é 1,2%. Se a moeda for a 3%, 5% ou 7%, o lucro vai junto, até a reversão.',
        beats: [
            {
                title: 'Quando o Bitcoin libera',
                text: 'O Bitcoin precisa estar em alta no gráfico de 4 horas, com a média subindo, o MACD a favor e o RSI numa zona saudável. Faltou uma dessas, um trade novo não abre. Esta opção não usa chance mínima. A decisão é essa combinação.'
            },
            {
                title: 'A moeda confirma',
                text: 'Com o Bitcoin a favor, a moeda confirma no gráfico de 1 hora. O RSI fica no meio da escala, o volume está alto e as últimas 24 horas não mostram queda forte nem alta esticada demais. Bitcoin e moeda apontam para o mesmo lado, e a compra sai.'
            },
            {
                title: 'Como faz o lucro',
                text: 'A moeda comprada sobe e o trade sobe com ela. O piso mínimo é 1,2%. O topo é livre: pode realizar 3%, 5% ou 7%, conforme a alta for. A venda sai na reversão. Se o Bitcoin virar no 4 horas, o USDC que ainda está livre fica parado e nenhum trade novo abre. O que já está comprado segue acompanhando a moeda até essa reversão.'
            }
        ],
        sells: true
    },
    {
        id: 'buy_only',
        index: '04',
        name: 'Só compra',
        tag: 'Opção 4',
        summary: 'Compra pelo viés de cinco dias e deixa a venda na sua mão.',
        pitch: 'A entrada é a mesma da opção de cinco dias: escolhe a moeda e compra sozinha. A diferença é a saída. Esta opção não vende na reversão e não usa o piso de 1,2%. O lucro fica com você até dolarizar.',
        beats: [
            {
                title: 'Como entra',
                text: 'Usa o mesmo teto de USDC, o mesmo percentual, o mesmo número de moedas, a mesma chance mínima e a mesma espera. O viés de cinco dias escolhe, o sinal técnico confirma, e a compra sai sozinha.'
            },
            {
                title: 'O trade fica aberto',
                text: 'A venda automática fica desligada. A moeda pode subir 3%, 5%, 7% ou mais, e a posição continua. Não há piso automático nem venda na reversão.'
            },
            {
                title: 'Quando você encerra',
                text: 'A saída é Encerrar e dolarizar, na hora que você decidir. Nessa venda, a regra da EasyCripto aplica 10% de comissão e 10% de fundo. Até lá, a moeda permanece na carteira.'
            }
        ],
        sells: false
    }
];

export function predatorById(id) {
    return PREDATORS.find(item => item.id === id) || null;
}

function filled(value) {
    return value !== null && value !== undefined && String(value).trim() !== '';
}

export function formatPct(value) {
    const number = Number(value);
    if (!Number.isFinite(number)) return '';
    return String(number).replace('.', ',');
}

export function hasSavedCoinCount(settings) {
    return filled(settings?.predadorCoinCount);
}

function positiveAmount(value) {
    const number = parseFloat(value);
    return Number.isFinite(number) && number > 0 ? number : 0;
}

export function huntSaldo(settings) {
    const percent = filled(settings?.predadorUsePercent)
        ? Math.min(100, Math.max(1, parseFloat(settings.predadorUsePercent) || 100))
        : 100;
    const ceiling = positiveAmount(settings?.predadorMaxUsdc) * (percent / 100);
    const free = positiveAmount(settings?.custodyUsdc);
    const wallet = positiveAmount(settings?.walletTotal);
    const equity = free > 0 ? free : wallet;
    if (ceiling > 0) return equity > 0 ? Math.min(ceiling, equity) : ceiling;
    return equity;
}

export function autoCoinCount(amount) {
    const budget = Number(amount) || 0;
    if (!(budget >= MIN_BUY_USDC)) return 0;
    return Math.min(MAX_AUTO_COINS, Math.floor(budget / MIN_BUY_USDC));
}

function formatUsdc(value) {
    const number = Number(value);
    if (!Number.isFinite(number)) return '';
    return number.toLocaleString('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
}

export function coinSplitText(settings, starting = false) {
    if (!settings || hasSavedCoinCount(settings)) return '';
    const saldo = huntSaldo(settings);
    const coins = autoCoinCount(saldo);
    if (coins < 1)
        return 'Sem número de moedas salvo. O saldo ainda não cobre a compra mínima de 5 USDC.';
    const each = saldo / coins;
    const size = `${coins} moeda${coins > 1 ? 's' : ''}, cerca de ${formatUsdc(each)} USDC cada`;
    if (starting)
        return `Dividi ${formatUsdc(saldo)} USDC em ${size}.`;
    return `Sem número de moedas salvo. ${formatUsdc(saldo)} USDC entram em ${size} (máximo 5, compra mínima 5).`;
}

export function hasPredatorConfig(settings) {
    if (!settings) return false;
    const profit = settings.predadorProfitMode;
    return filled(settings.predadorStopLoss)
        || profit === 'classic'
        || profit === DEFAULT_PROFIT;
}

export function isHuntPaused(settings) {
    return settings?.predadorHuntPaused === true
        || settings?.predadorHuntPaused === 1
        || settings?.predadorHuntPaused === '1'
        || settings?.predadorHuntPaused === 'true';
}

export function startPayload(predatorId, settings) {
    const payload = {
        predadorHuntMode: predatorId,
        predadorHuntPaused: false
    };
    if (!hasPredatorConfig(settings)) {
        payload.predadorStopLoss = DEFAULT_STOP;
        payload.predadorProfitMode = DEFAULT_PROFIT;
    }
    return payload;
}

export function planText(settings) {
    const exit = !hasPredatorConfig(settings)
        ? 'Começar usa stop de 1,5%. O trade acompanha a alta: piso de 1,2%, e o lucro pode ir a 3%, 5% ou 7% até a reversão.'
        : `Stop de ${filled(settings?.predadorStopLoss) ? formatPct(settings.predadorStopLoss) + '%' : '1,5%'}. O trade acompanha a alta, com piso de 1,2%, e vende na reversão.`;
    const coins = coinSplitText(settings);
    return coins ? `${exit} ${coins}` : exit;
}

export function huntBlockedReason(settings) {
    if (!hasSavedCoinCount(settings)) {
        if (autoCoinCount(huntSaldo(settings)) < 1)
            return 'O saldo não cobre a compra mínima de 5 USDC. A opção fica ligada, mas só compra quando der para abrir pelo menos uma moeda.';
        return '';
    }
    const max = parseFloat(settings?.predadorMaxUsdc);
    const coins = parseInt(settings.predadorCoinCount, 10);
    if (!(max > 0))
        return 'O teto de USDC está zerado. A opção fica ligada, mas só compra depois que você definir o teto em Configurações.';
    if (!(coins > 0))
        return 'O número de moedas está em zero. A opção fica ligada, mas só compra depois que você definir ao menos uma moeda em Configurações.';
    return '';
}

export function startedText(predator, settings, usedDefault) {
    const exit = predator.sells
        ? (usedDefault
            ? 'Stop de 1,5%. O trade acompanha a alta, piso de 1,2%, e vende na reversão. Se a moeda for a 3%, 5% ou 7%, o lucro vai junto.'
            : `Stop de ${filled(settings?.predadorStopLoss) ? formatPct(settings.predadorStopLoss) + '%' : '1,5%'}. O trade acompanha a alta e vende na reversão.`)
        : 'A compra fica automática. A venda continua na sua mão, até dolarizar.';
    const coins = coinSplitText(settings, true);
    return [`${predator.name} ligado.`, exit, coins].filter(Boolean).join(' ');
}
